export const SENTRY_DSN = "https://82a44a0f1042d3b49fc3638315406738@o4510583122952192.ingest.us.sentry.io/4510583141040128";
